import { OnboardingAuditOverrideStatus } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { FormTextareaField, lt, useToggle } from '@mews/framework';
import { Body, Stack, Title, Toggle } from '@optimus-web/core';
import { fieldNames } from './schema';

export const UpdateOnboardingAuditFormContent = ({
    manualOverride,
    resetStatusField,
}: {
    manualOverride: boolean;
    resetStatusField: () => void;
}) => {
    const [statusActive, toggleStatus] = useToggle({ initialValue: manualOverride });

    const handleToggle = () => {
        if (statusActive) {
            resetStatusField();
            toggleStatus();
        } else {
            toggleStatus();
        }
    };

    return (
        <Stack spacing="200" vertical>
            <Stack spacing="50" vertical>
                <Stack distribution="space-between">
                    <Title level={3}>{lt('OnboardingAuditOverrideFormStatusTitle')}</Title>
                    <Toggle checked={statusActive} onChange={handleToggle} />
                </Stack>
                <Body size="small" variant="secondary">
                    {lt('OnboardingAuditOverrideFormStatusHint')}
                </Body>
                {statusActive && (
                    <EnumSelectField
                        enumPrefix="OnboardingAuditOverrideStatus"
                        enumClass={OnboardingAuditOverrideStatus}
                        name={fieldNames.overrideStatus}
                        label={lt('Status')}
                        showEmptyValue={false}
                        size="medium"
                        omitHint
                    />
                )}
            </Stack>
            <Stack spacing="50" vertical>
                <Title level={3}>{lt('OnboardingAuditOverrideFormNotesTitle')}</Title>
                <Body size="small" variant="secondary">
                    {lt('OnboardingAuditOverrideFormNotesHint')}
                </Body>
                <FormTextareaField name={fieldNames.notes} label={lt('Note')} />
            </Stack>
        </Stack>
    );
};
